"use client";

/**
 * Shows candidate suggestions when a case reference isn't found.
 * User can click one to correct the query and re-run checks.
 */
export default function CandidateList({ q, candidates, onSelect }: {
  q: string;
  candidates: Array<{
    kind: string;
    ref_id: string;
    display: string;
    popular_name?: string | null;
    court_code?: string | null;
    decision_date?: string | null;
    title?: string | null;
    authors?: string[] | null;
    year?: number | null;
    label?: string | null;
    score: number;
    arms: string[];
    reasons: string[];
  }>;
  onSelect: (candidate: { display: string }) => void;
}) {
  const courtNames: Record<string, string> = {
    HDO: "Högsta domstolen",
    HFD: "Högsta förvaltningsdomstolen",
    AD: "Arbetsdomstolen",
    MD: "Marknadsdomstolen",
    MOD: "Marknads- och miljööverdomstolen",
    MIOD: "Migrationsöverdomstolen",
    RA: "Regeringsrätten",
  };

  if (candidates.length === 0) return null;

  return (
    <div className="candidate-panel">
      <p className="candidate-label">Möjligen menade du:</p>
      <div className="candidate-list card-grid" role="list">
        {candidates.slice(0, 5).map((c) => {
          const hasExtras = c.popular_name || (c.court_code && c.decision_date) || (c.title && c.authors?.length && c.year);
          return (
            <button
              type="button"
              key={c.ref_id}
              className="btn-bare candidate-item"
              onClick={() => onSelect(c)}
              aria-label={`Välj ${c.display}`}
              title={c.display}
              style={{ textAlign: "left" }}
            >
              <span className="candidate-main">{c.display}</span>
              {hasExtras && (
                <span className="candidate-meta">
                  {c.popular_name ? `${c.popular_name} ` : ""}
                  {(c.court_code && c.decision_date) ? `${courtNames[c.court_code] ?? c.court_code} ${c.decision_date}`.trim() + " · " : ""}
                  {(c.title && c.authors?.length && c.year) ? `${c.title} — ${(c.authors.slice(0, 2).join(", ") + (c.authors.length > 2 ? " o.a." : ""))}, ${c.year}`.trim() : ""}
                </span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}